/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteFragmentDetailByIdMutationResponse, DeleteFragmentDetailByIdPathParams, DeleteFragmentDetailById403, DeleteFragmentDetailById404 } from "../models/DeleteFragmentDetailById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteFragmentDetailById } from "../axios/deleteFragmentDetailById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteFragmentDetailByIdMutationKey = () => ["web-app-bff-api", { url: '/fragments/:id' }] as const

export type DeleteFragmentDetailByIdMutationKey = ReturnType<typeof deleteFragmentDetailByIdMutationKey>

export function deleteFragmentDetailByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteFragmentDetailByIdMutationKey()
        return mutationOptions<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, {id: DeleteFragmentDetailByIdPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteFragmentDetailById(id, config)
          },
        })

}

/**
 * @summary Delete one fragment by id
 * {@link /fragments/:id}
 */
export function useDeleteFragmentDetailById<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, {id: DeleteFragmentDetailByIdPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteFragmentDetailByIdMutationKey()

          const baseOptions = deleteFragmentDetailByIdMutationOptions(config) as UseMutationOptions<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, {id: DeleteFragmentDetailByIdPathParams["id"]}, TContext>
          

          return useMutation<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, {id: DeleteFragmentDetailByIdPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, {id: DeleteFragmentDetailByIdPathParams["id"]}, TContext>
      
}